import { FaEdit } from "react-icons/fa";
import { useProposedChallengeMutation } from "../../../queries/challenge";
import { useNavigate } from "react-router-dom";
import Chip from "../../../components/Chip";
const GreenTick = require("../../../utils/media/icons/greentick.png");
const ViewIcon = require("../../../utils/media/icons/view_icon.png");
const RedCross = require("../../../utils/media/icons/redcross.png");

const ProposedChallengesListTable = ({ data = [], toast }) => {

    const navigate = useNavigate();

    const { mutate: mutateChallenge, isLoading: isAccepting } = useProposedChallengeMutation("open for voting");

    const renderChipStatus = (data) => {
        if (data?.acceptanceStatus === 'live in app') {
            return <Chip value={data?.acceptanceStatus} variant={'filled'} color="green" />;
        } else if (data?.acceptanceStatus === 'rejected') {
            return <Chip value={data?.acceptanceStatus} variant={'filled'} color="red" />;
        } else if (data?.acceptanceStatus === 'pending') {
            return <Chip value={data?.acceptanceStatus} variant={'filled'} color="yellow" />;
        } else if (data?.acceptanceStatus === 'open for voting') {
            return <Chip value={data?.acceptanceStatus} variant={'filled'} color="purple" />;
        } else if (data?.acceptanceStatus === 'voting over') {
            return <Chip value={data?.acceptanceStatus} variant={'filled'} color="magenta" />;
        } else {
            return <Chip value={data?.acceptanceStatus} variant={'filled'} color="blue" />;
        }
    }
    
    const handleAccept = (challengeId) => {
        mutateChallenge(({ challengeId: challengeId, status: "open for voting" }), {
            onSuccess: () => {
                toast.success("Challenge accepted successfully!");
            },
            onError: (error) => {
                toast.error("Failed to accept the challenge.");
                console.error(error);
            },
        });
    }

    const handleReject = (challengeId) => {
        mutateChallenge(({ challengeId: challengeId, status: "rejected" }), {
            onSuccess: () => {
                toast.success("Challenge rejected successfully!");
            },
            onError: (error) => {
                toast.error("Failed to reject the challenge.");
                console.error(error);
            },
        });
    };

    return (
        <div className="overflow-x-auto mt-6">
            <table className="w-full border-collapse overflow-visible" role="table">
                <thead className="bg-navBtn">
                    <tr className="rounded-md">
                        <th className="p-3 text-left">Srl. No.</th>
                        <th className="p-3 text-left">Category</th>
                        <th className="p-3 text-left">Name</th>
                        <th className="p-3 text-left">Proposed By</th>
                        <th className="p-3 text-center">Votes</th>
                        <th className="p-3 text-center">Created At</th>
                        <th className="p-3 text-center">Voting Ends At</th>
                        <th className="p-3 text-center">Status</th>
                        <th className="p-3 text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {!data?.length ? (
                        <tr>
                            <td colSpan="9" className="p-6 text-center text-gray-500">
                                No proposed challenges found
                            </td>
                        </tr>
                    ) : (
                        data.map((item, index) => (
                            <tr
                                key={item._id}
                                className="border-b border-navBtn hover:bg-gray-50 relative"
                            >
                                <td className="p-3 text-center">{index + 1}</td>
                                <td className="p-3">{item?.category?.name ? item.category.name : 'Unknown'}</td>
                                <td className="p-3">{item?.name}</td>
                                <td className="p-3">{item?.proposedByUser?.userName || 'Unknown'}</td>
                                <td className="p-3 text-center">{item?.upvotes.length}</td>
                                <td className="p-3 text-center">{new Date(item?.createdAt).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric' })}</td>
                                <td className="p-3 text-center">{item?.challengeCreation?.canCreationDate ? (new Date(item?.challengeCreation?.canCreationDate).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric' })) : "-"}</td>
                                <td className="p-3 text-center capitalize">{renderChipStatus(item)}</td>
                                <td className="p-3 text-center flex items-center justify-center">
                                    {/* Add action buttons here */}
                                    {/* <button
                                            className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] min-h-7 relative group"
                                            onClick={() => handleAccept(item._id)}
                                        >
                                            <img src={GreenTick} className="size-4" />
                                            <span className="absolute z-20 bottom-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block bg-[rgba(0,122,155,0.5)] backdrop-blur text-white text-xs rounded py-1 px-2">
                                                Open For Voting
                                            </span>
                                        </button> */}
                                    {/* <button
                                            className="rounded p-1.5 bg-[rgba(250,22,22,0.1)] hover:bg-[rgba(250,22,22,0.2)] min-h-7 ml-1 px-2 relative group"
                                            onClick={() => handleReject(item._id)}
                                        >
                                            <img src={RedCross} className="size-3" />
                                            <span className="absolute bottom-full mb-1 hidden group-hover:block bg-inactive backdrop-blur text-white text-xs rounded py-1 px-2 right-0">
                                                Reject
                                            </span>
                                        </button> */}
                                    <button className="rounded p-1.5 bg-[rgba(52,199,89,0.1)] hover:bg-[rgba(52,199,89,0.2)] mx-1 min-h-7" onClick={() => navigate('/challenges/proposed-challenges-details', { state: { proposedChallengeId: item?._id } })}>
                                        <img src={ViewIcon} alt="view" />
                                    </button>
                                    {/* {
                                            new Date(item?.challengeCreation?.canCreationDate) > new Date() && */}
                                    {/* <button
                                        className="rounded p-1.5 bg-[rgba(0,122,155,0.1)] hover:bg-[rgba(0,122,155,0.2)] min-h-7 ml-1 relative group"
                                        onClick={() => navigate("/challenges/challenges-main/create-challenge", {
                                            state: {
                                                challengeName: item.name,
                                                challengeDescription: item?.description,
                                                challengeInspireMe: item?.inspireMe,
                                                challengeProposedByUser: item?.proposedByUser,
                                                challengeCategory: item?.category,
                                                proposedChallengeId: item?._id,
                                                challengeCoverImage: item?.sampleMedia[0],
                                            }
                                        })}
                                    >
                                        <FaEdit className='text-[rgba(0,122,155,0.5)]' />
                                        <span className="absolute bottom-full mb-1 hidden group-hover:block bg-[rgba(0,122,155,0.5)] backdrop-blur text-white text-xs rounded py-1 px-2 right-0">
                                            Create Challenge
                                        </span>
                                    </button> */}
                                    {/* } */}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default ProposedChallengesListTable;